var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d-card',{staticClass:"dash-card",class:['stats-small', _vm.computedVariationClass, 'card', 'card-small']},[_c('d-card-body',{class:[_vm.computedBodyClass]},[_c('div',{class:['d-flex', _vm.computedInnerWrapperClass]},[_c('div',{class:['stats-small__data', _vm.computedDataFieldClass]},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
            content: _vm.explanation,
            placement: 'top-center',
            offset: 0,
            
          }),expression:"{\n            content: explanation,\n            placement: 'top-center',\n            offset: 0,\n            \n          }"}],class:[
            'stats-small__label',
            'text-uppercase',
            _vm.computedLabelClass
          ]},[_vm._v(_vm._s(_vm.label))]),_c('h6',{class:['stats-small__value', 'count', _vm.computedValueClass]},[_vm._v(_vm._s(_vm.value))])])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }